export function delay(duration = 0) {
    return new Promise((resolve) => {
        if (!duration)
            resolve(true);
        setTimeout(() => resolve(true), duration);
    });
}
